import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MicInvComb } from 'src/app/models/mic-inv-comb';
import { CarregandoService } from 'src/app/services/carregando.service';
import { MicInvCombService } from 'src/app/services/mic-inv-comb.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { InfoRegrasModalComponent } from '../info-regras-modal/info-regras-modal.component';
import { SelecionaProdutoModalComponent } from '../seleciona-produto-modal/seleciona-produto-modal.component';
import { ProdutosV2ModalComponent } from "../produtos-v2-modal/produtos-v2-modal.component";
import { SelecionaProdutoV2ModalComponent } from "../seleciona-produto-v2-modal/seleciona-produto-v2-modal.component";
import { PremissasSistema } from "../../models/premissas-sistema";
import { PremissasService } from "../../services/premissas.service";
import { TipoFiltroProduto } from "../../models/enum";

// jquery
declare const $: any;


@Component({
  selector: 'app-mic-inv-comb-modal',
  templateUrl: './mic-inv-comb-modal.component.html',
  styleUrls: ['./mic-inv-comb-modal.component.scss']
})
export class MicInvCombModalComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};
  micInvComb: MicInvComb;
  editando: boolean;
  premissasSistema: PremissasSistema = new PremissasSistema();

  constructor(
    public dialogRef: MatDialogRef<MicInvCombModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private micInvCombService: MicInvCombService,
    public dialog: MatDialog,
    private premissasService: PremissasService,
    ) {
    this.micInvComb = data.micInvComb;
    this.editando = data.editando;
  }

  ngOnInit(): void {
    this.buscarPremissasSistema().then();
  }

  async buscarPremissasSistema() {
    try {
      this.carregandoService.mostra('buscarPremissasSistema');
      this.premissasSistema = await this.premissasService.consultarPremissasSistema().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasSistema');
    }
  }

  voltar() {
    this.dialogRef.close();
  }

  salvar() {
    this.carregandoService.mostra('salvar');
    this.micInvCombService.salvar(this.micInvComb).subscribe(
      (retorno) => {

        this.notificacaoService.sucesso('Combinação salva com sucesso!!!');
        this.dialogRef.close(this.micInvComb);
        this.carregandoService.esconde('salvar');
      },
      (erro) => {
        this.carregandoService.esconde('salvar');
        this.notificacaoService.erro(erro);
      }
    );
  }

  selecionarProduto() {
    const largura = Number(($('body').width()));
    let dialogRef;
    const config = {
      width: largura > 930 ? '900px' : $('body').width().toString() + 'px',
      data: {
        editando: false,
        semKit: true
      },
      panelClass: 'modal-card',
      maxHeight: '98vh'
    };

    if (this.premissasSistema.filtroProduto === TipoFiltroProduto.Agrupamento) {
      dialogRef = this.dialog.open(SelecionaProdutoModalComponent, config);
    } else {
      dialogRef = this.dialog.open(SelecionaProdutoV2ModalComponent, config);
    }

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.micInvComb.idProduto = result.produto;
        this.micInvComb.descricao = result.produtoTela.descricao;
      }
    });
  }

  infos() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(InfoRegrasModalComponent, {
      width: largura > 930 ? '900px' : $('body').width().toString() + 'px',
      data: {},
      panelClass: 'modal-card',
      maxHeight: '98vh'
    });

    dialogRef.afterClosed().subscribe(result => {

    });

  }

}
